import { createContext } from '@chakra-ui/react-utils';
import { PropsWithChildren } from 'react';

export type FileProps = {
  filename: string;
  fileSize: number;
  fileType: string;
  uploaded: string;
  containsVirus?: boolean;
  uuid?: string | null;
  highlight?: string | null;
  isDisabled?: boolean;
  isLoading?: boolean;
  isReadOnly?: boolean;
  assemblyParentFilename?: string;
};

export const [FileContextProvider, useFileContext] = createContext<FileProps>({
  name: 'FileContext',
  errorMessage:
    'useFileContext: `context` is undefined. Seems you forgot to wrap all file components within `<FileProvider />`',
});

export type FileProviderProps = PropsWithChildren<FileProps>;

export const FileProvider = ({ children, ...restProps }: FileProviderProps) => {
  return (
    <FileContextProvider value={{ ...restProps }}>
      {children}
    </FileContextProvider>
  );
};
